import React, { useState, useEffect } from 'react';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import dabangBridge from '~/utils/bridge';

import BG from '~/components/background';
import img1Img from './images/img_01.png';
import img5Img from './images/img_05.png';
import title01 from './images/title01.png';
import title02 from './images/title02.png';
import banner01 from './images/banner01.png';
import banner02 from './images/banner02.png';
import banner03 from './images/banner03.png';
import imgbtn from './images/imgbtn.png';

import {
  Wrap, Box, TextInput, TextBox, Select, BtnWrap,
  InputBox, TextLabel, SelectWrap, Input, AgreeCheckBox, AgreeTextBox, AgreeWrap,
} from './styled';

function EventComponent() {
  const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL;
  const [isAgree, setAgree] = useState(false);
  const [codeList, setCodeList] = useState([]);
  const [cityList, setCitylist] = useState([]);
  const [state, setState] = useState({
    name: '',
    phone: '',
    age: 0,
    gender: '',
    stateCode: '',
    cityCode: '',
    q1: '',
    q2: '',
    inputText: ''
  })
  const [isSending, setSending] = useState(false);

  useEffect(() => {
    getStateCode();
  }, [])

  useEffect(() => {
    if (state.stateCode !== '') {
      getCityCode();
    } else {
      setCitylist([]);
    }
  }, [state.stateCode])

  async function getStateCode() {
    try {
      const list = await apiCall.get(`${host}/api/v1/regions/state`);
      setCodeList(list.result);
    } catch (err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  async function getCityCode() {
    try {
      const list = await apiCall.get(`${host}/api/v1/regions/city?stateCode=${state.stateCode}`);
      setCitylist(list.result);
    } catch (err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  function onChange(e) {
    const { name, value } = e.currentTarget;

    if (name === 'phone') {
      if (value.match(/e|-|\+|=| |,|\./g)) return;
      if (!/\d/.test(+value)) return;
      if (value.length > 11) return;
    }

    if (name === 'stateCode') {
      setState(prev => ({ ...prev, stateCode: value, cityCode: '' }));
    } else {
      setState(prev => ({ ...prev, [name]: value }));
    }
  }

  function onCheckAgree() {
    setAgree(prev => !prev);
  }

  async function submit() {
    if (state.q1 === '') return alert('질문1를 선택해주세요.');
    if (state.q2 === '') return alert('질문2를 선택해주세요.');
    if (state.name === '') return alert('이름을 입력해주세요.');
    if (state.phone === '') return alert('휴대폰번호를 입력해주세요.');
    if (state.age === '') return alert('나이를 입력해주세요.');
    if (state.gender === '') return alert('성별을 입력해주세요.');
    if (state.stateCode === '') return alert('시/도를 선택해주세요.');
    if (state.cityCode === '') return alert('군/구를 선택해주세요.');
    if (+state.q1 === 6 && state.inputText === '') return alert('질문1의 기타 의견을 입력해주세요.');
    if (!isAgree) return alert('본 이벤트는 정보입력 및 개인정보 수집/이용 항목에 동의 후 참여가능 합니다.');
    if (isSending) return;

    setSending(true);

    try {
      const res = await apiCall.post(`${host}/api/v1/event/complex-survey`, {
        ...state,
        age: +state.age,
        q1: +state.q1,
        q2: +state.q2,
        inputText: +state.q1 !== 6 ? '' : state.inputText,
      });

      setSending(false);

      if (res?.code === 200) {
        alert('참여해주셔서 감사합니다. 살고 싶은 아파트 정보, 다방에서 확인해보세요!');

        dabangBridge.android(call => {
          call.finishActivity();
        });

        dabangBridge.ios(call => {
          call.callHandler('ObjC Echo', {
            cmd: 'finishActivity',
          });
        });
      } else {
        alert(res?.msg);
      }

      setSending(false);
    } catch (err) {
      console.log(err);
      setSending(false);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return (
    <>
      <BG width={710} height={1537} imgUrl={img1Img} />
      <Wrap>
        <BG width={610} height={45} imgUrl={title01} />
        <Box>
          <div>
            <BG width={610} height={115} imgUrl={banner01} />
            <TextBox>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="0"
                  onChange={onChange} />
                <p>고급스러운 브랜드 이미지</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="1"
                  onChange={onChange} />
                <p>희소성과 상징성</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="2"
                  onChange={onChange} />
                <p>우수한 입지 (교통, 학군)</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="3"
                  onChange={onChange} />
                <p>높은 시세</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="4"
                  onChange={onChange} />
                <p>뛰어난 디자인과 고급 자재</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="5"
                  onChange={onChange} />
                <p>커뮤니티 시설 (조식제공, 수영장 등)</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="6"
                  onChange={onChange} />
                <p>기타 (직접 입력)</p>
              </label>
              <Input
                type="text"
                name="inputText"
                value={state.inputText}
                onChange={onChange}
                placeholder="떠오르는 생각을 자유롭게 입력해주세요."
                disabled={+state.q1 !== 6 || state.q1 === ''} />
            </TextBox>
          </div>
        </Box>
        <Box>
          <div>
            <BG width={610} height={115} imgUrl={banner02} />
            <TextBox>
              <label>
                <input
                  type="radio"
                  name="q2"
                  value="0"
                  onChange={onChange} />
                <p>아크로 (ex.아크로서울포레스트)</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q2"
                  value="1"
                  onChange={onChange} />
                <p>푸르지오 써밋 (ex.과천써밋)</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q2"
                  value="2"
                  onChange={onChange} />
                <p>디에이치 (ex.디에이치개포)</p>
              </label>
              <label>
                <input
                  type="radio"
                  name="q2"
                  value="3"
                  onChange={onChange} />
                <p>르엘 (ex.르엘대치)</p>
              </label>
            </TextBox>
          </div>
        </Box>
        <BG width={610} height={45} imgUrl={title02} />
        <Box>
          <div>
            <BG width={610} height={115} imgUrl={banner03} />
            <InputBox>
              <p>이름<span>*</span></p>
              <TextInput
                type="text"
                value={state.name}
                name="name"
                onChange={onChange}
                placeholder="예) 김다방" />
              <p>핸드폰 번호<span>*</span></p>
              <TextInput
                type="text"
                value={state.phone}
                name="phone"
                onChange={onChange}
                placeholder="예) 010-1234-5678" />
              <p>나이<span>*</span></p>
              <Select name="age" value={state.age} onChange={onChange}>
                <option value="">연령대를 선택해주세요</option>
                <option value="10">10대</option>
                <option value="20">20대</option>
                <option value="30">30대</option>
                <option value="40">40대</option>
                <option value="50">50대 이상</option>
              </Select>
              <p>성별<span>*</span></p>
              <TextLabel>
                <label>
                  <input
                    type="radio"
                    value="남"
                    name="gender"
                    onChange={onChange} />
                  <p>남자</p>
                </label>
                <label>
                  <input
                    type="radio"
                    value="여"
                    name="gender"
                    onChange={onChange} />
                  <p>여자</p>
                </label>
              </TextLabel>
              <p>지역<span>*</span></p>
              <SelectWrap>
                <select name="stateCode" value={state.stateCode} onChange={onChange}>
                  <option value="">시/도</option>
                  {codeList.map(i => <option key={i.code} value={i.code}>{i.name}</option>)}
                </select>
                <select name="cityCode" value={state.cityCode} onChange={onChange}>
                  <option value="">군/구</option>
                  {cityList.map(i => <option key={i.code} value={i.code}>{i.name}</option>)}
                </select>
              </SelectWrap>
            </InputBox>
          </div>
        </Box>
        <AgreeWrap>
          <div>
            <AgreeCheckBox>
              <input type="checkbox" checked={isAgree} onChange={onCheckAgree} />
              <p>개인정보 이용 및 처리에 대한 동의</p>
            </AgreeCheckBox>
            <AgreeTextBox>
              <div>
                <span>1.</span>
                <p>개인정보 수집, 이용 목적: 당첨자 본인 확인 및 이벤트 경품 발송</p>
              </div>
              <div>
                <span>2.</span>
                <p>수집하는 개인정보 항목: 이름, 연락처</p>
              </div>
              <div>
                <span>3.</span>
                <p>개인정보 보유 및 이용기간: 이벤트 종료후 60일 까지</p>
              </div>
              <div>
                <span>4.</span>
                <p>동의 및 철회방법: 다방 대표번호를 통해 철회를 요청하시면 15일 이내 개인정보 열람을 할 수 없도록 삭제 및 파기됩니다.</p>
              </div>
              <div>
                <span>5.</span>
                <p>개인정보 이용의 거부: 개인정보 이용 및 처리에 대한 동의를 하지 않으실 경우, 부득이하게 이벤트 당첨 사실이 취소됨을 알려드립니다.</p>
              </div>
            </AgreeTextBox>
          </div>
        </AgreeWrap>
        <BtnWrap onClick={submit}>
          <BG width={620} height={120} imgUrl={imgbtn} />
        </BtnWrap>
      </Wrap>
      <BG width={710} height={1107} imgUrl={img5Img} />
    </>
  );
}

export default EventComponent;
